export interface SelectQuery {
    selection: string;
    aliasName?: string;
    virtual?: boolean;
}